<script lang="ts" setup>
import { v4 as uuid } from 'uuid'
import type { HomePageConfig } from '../../configs/types'
import ModuleCard from './ModuleCard.vue'

const props = defineProps<{
  module: any
  config: HomePageConfig
  cardClass?: string
  headerClass?: string
  gotoBook: (id: string) => void
  gotoCollection: (id: string) => void
}>()

function handleSeeAll() {
  props.gotoCollection(props.module.id)
}
</script>

<template>
  <ModuleCard
    :title-text="module.showName"
    :action-text-value="config.texts.seeAll"
    :card-class="cardClass"
    :header-class="headerClass"
    @action="handleSeeAll"
  >
    <div class="mt-2 grid grid-cols-4 gap-2">
      <div v-for="item in module.resourceList.records.slice(0, 8)" :key="item.id">
        <div class="mt-4" @click="gotoBook(item.id)">
          <BizBookCover
            :id="uuid()"
            :src="item.contentCoverUrl || ''"
            :small-theater="!!item.small_theater"
            :extra="{
              module_name: module.showName,
              module_id: module.id,
              module_type: module.columnType,
              author: item.authorInfo.author,
              ...item,
            }"
            class="rounded-8px"
          />
          <p class="mt-10px text-14px text-n-text-1 calculate-width-3 line-clamp-2">
            {{ item.contentName }}
          </p>
          <p v-if="item.tagList?.length" class="mt-4px text-11px truncate tag-line calculate-width-3">
            {{ item.tagList.slice(0, 2).map(t => t.name).join(' / ') }}
          </p>
        </div>
      </div>
    </div>
  </ModuleCard>
</template>

<style lang="scss" scoped>
.calculate-width-3 {
  width: calc((100vw - 60px) / 4 - 5px);
}

.tag-line {
  color: #ff5ace;
}
</style>
